import { render, staticRenderFns } from "./proAgentAmount.vue?vue&type=template&id=7b10d2ff&"
import script from "./proAgentAmount.vue?vue&type=script&lang=js&"
export * from "./proAgentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports